import React from 'react';
import './Certifications.css';

import certs from '../../../assets/images/certs.png';

const Certifications = () => {
  return (
    <div className="px-10 py-4  bg-white ">
      <h1 className="cert-title mt-5 ml-10">Certifications</h1>
      <div className="flex flex-col md:flex-row sm:flex-row  grid-cols-2 gap-4 justify-center relative">
        <div className="ml-10">
          <p className="cert-description my-4">
            PartsBadger takes the necessary measures to ensure our customer are confident sourcing a machining partner to get parts done on-time and in-spec.
          </p>
        </div>
        <div className="justify-center ml-10">
          <img className="cert-img ml-10" alt="certifications" src={certs} />
        </div>
      </div>
    </div>
  )
}

export default Certifications;
